import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaExternalLinkAlt } from "react-icons/fa"; // Import "Open Web" icon
import "./StoresListing.css";
import WebViewCard from "../../components/commonComponent/WebViewCard";

const API_URL = process.env.REACT_APP_API_URL;

const StoreWebView = () => {
  const [stores, setStores] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchStores = async () => {
      const response = await fetch(`${API_URL}/getAllStores`);
      const data = await response.json();
      console.log(data, "Fetched stores");

      setStores(data?.data || []);
    };

    fetchStores();
  }, []);

  return (
    <div className="blog-listing" >
      <div className="blog-container grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {stores.length > 0 ? (
          stores.map((store) => (
            <WebViewCard  key={store.id} title={store.title} path={store.link} newWindow={true}/>
          ))
        ) : (
          <p className="text-gray-600 text-center">Loading stores...</p>
        )}
      </div>
    </div>
  );
};

export default StoreWebView;
